export function elementInView(_sel) {
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('site-farlo-ui-animated--has-animated');
            }
        });
    });

    observer.observe(_sel);
}